import notificationalertService from "@/api/notificationalert";
import { NOTIFICATIONALERT } from '../types'
import errorhandler from '@/utils/errorhandler.js'

export default {
  namespaced: true,
  state: {
    notificationAlerts: [],
    id: '',
    name: '',
    locations: [],
    days: [],
    allDay: true,
    allLocations: true,
    measures: [],
    recipients: [],
    startTime: null,
    finishTime: null
  },
  getters:{
    name: (state) => {
      return state.name
    },
    locations: (state) => {
      return state.locations
    },
    days: (state) => {
      return state.days
    },
    allDay: (state) => {
      return state.allDay
    },
    allLocations: (state) => {
      return state.allLocations
    },
    measures: (state) => {
      return state.measures
    },
    startTime: (state) => {
      return state.startTime
    },
    finishTime: (state) => {
      return state.finishTime
    }
  },
  mutations: {
    [NOTIFICATIONALERT.SET_NOTIFICATION_ALERTS](state, value) {
      state.notificationAlerts = value
    },
    [NOTIFICATIONALERT.SET_ID](state, value) {
      state.id = value
    },
    [NOTIFICATIONALERT.SET_NAME](state, value) {
      state.name = value
    },
    [NOTIFICATIONALERT.SET_LOCATIONS](state, value) {
      state.locations = value
    },
    [NOTIFICATIONALERT.SET_DAYS](state, value) {
      state.days = value
    },
    [NOTIFICATIONALERT.SET_ALL_DAY](state, value) {
      state.allDay = value
    },
    [NOTIFICATIONALERT.SET_ALL_LOCATIONS](state, value) {
      state.allLocations = value
    },
    [NOTIFICATIONALERT.SET_MEASURES](state, value) {
      state.measures = value
    },
    [NOTIFICATIONALERT.SET_RECIPIENT](state, value) {
      state.recipients.push(value)
    },
    [NOTIFICATIONALERT.REMOVE_RECIPIENT] (state, value) {
      state.recipients.splice(value, 1)
    },
    [NOTIFICATIONALERT.SET_STARTTIME](state, value) {
      state.startTime = value
    },
    [NOTIFICATIONALERT.SET_FINISHTIME](state, value) {
      state.finishTime = value
    },
    [NOTIFICATIONALERT.CLEAR_RECIPIENTS](state) {
      state.recipients = []
    },
    [NOTIFICATIONALERT.SET_RECIPIENTS](state, value) {
      state.recipients = value
    },
  },
  actions: {
    getAllAlerts({ commit, dispatch }) {
      dispatch('Global/showLoading', null, { root: true })
      return new Promise((resolve) => {
        notificationalertService.getAllAlerts().then((response) => {
          commit(NOTIFICATIONALERT.SET_NOTIFICATION_ALERTS, response.data)
          resolve()
        }).finally(() => {
          dispatch('Global/hideLoading', null, { root: true })
        })
      })
    },
    async saveAlert({dispatch, state, commit}){
      const alert = {
        id: state.id,
        name: state.name,
        measures: state.measures,
        allDayAlert: state.allDay,
        startTime: !state.allDay ? state.startTime : null,
        finishTime: !state.allDay ? state.finishTime : null,
        allLocations: state.allLocations,
        locationIds: state.locations.map(l => l.id),
        weekDays: state.days,
        userEmails: state.recipients.map(r => r.email)
      }

      dispatch('Global/showLoading', null, {root: true})
      try {
        await notificationalertService.saveAlert(alert)
        await dispatch('getAllAlerts')
        dispatch('Global/showMessage', alert.id ? 'editAlertSuccessfully' : 'addAlertSuccessfully', {root: true})
      }
      catch(response){
        errorhandler.handleError(response)
      }
      finally {
        dispatch('Global/hideLoading', null, {root: true})
        commit(NOTIFICATIONALERT.SET_ID, '')
      }
    },
    async removeAlert({dispatch}, id){
      dispatch('Global/showLoading', null, {root: true})
      try {
        await notificationalertService.removeAlert(id)
        await dispatch('getAllAlerts')
        dispatch('Global/showMessage', 'removeAlertSuccessfully', {root: true})
      }
      finally {
        dispatch('Global/hideLoading', null, {root: true})
      }
    },
    async getAlert({dispatch, commit}, id){
      dispatch('Global/showLoading', null, { root: true })
      return new Promise((resolve) => {
        notificationalertService.getAlert(id).then((response) => {
          const result = response.data

          commit(NOTIFICATIONALERT.SET_ID, result.id)
          commit(NOTIFICATIONALERT.SET_NAME, result.name)
          commit(NOTIFICATIONALERT.SET_MEASURES, result.measures)
          commit(NOTIFICATIONALERT.SET_ALL_DAY, result.allDayAlert)
          commit(NOTIFICATIONALERT.SET_STARTTIME, result.startTime)
          commit(NOTIFICATIONALERT.SET_FINISHTIME, result.finishTime)
          commit(NOTIFICATIONALERT.SET_ALL_LOCATIONS, result.allLocations)
          commit(NOTIFICATIONALERT.SET_LOCATIONS, result.locations)
          commit(NOTIFICATIONALERT.SET_DAYS, result.weekDays)
          commit(NOTIFICATIONALERT.SET_RECIPIENTS, result.userEmails.map(e => ({ email : e })))

          resolve()
        }).finally(() => {
          dispatch('Global/hideLoading', null, { root: true })
        })
      })
    },
    setName({commit}, name){
      commit(NOTIFICATIONALERT.SET_NAME, name)
    },
    setLocations({commit}, locations){
      commit(NOTIFICATIONALERT.SET_LOCATIONS, locations)
    },
    setDays({commit}, days){
      commit(NOTIFICATIONALERT.SET_DAYS, days)
    },
    setAllDay({commit}, allDay){
      commit(NOTIFICATIONALERT.SET_ALL_DAY, allDay)
    },
    setAllLocations({commit}, allLocations){
      commit(NOTIFICATIONALERT.SET_ALL_LOCATIONS, allLocations)
    },
    setMeasures({commit}, measures){
      commit(NOTIFICATIONALERT.SET_MEASURES, measures)
    },
    setRecipient ({ commit, }, item) {
      let recipient = item.email? {email: item.email, name: item.name} : {email: item}
      commit(NOTIFICATIONALERT.SET_RECIPIENT, recipient)
    },
    removeRecipient ({ commit }, index) {
      commit(NOTIFICATIONALERT.REMOVE_RECIPIENT, index)
    },
    setStartTime({commit}, startTime){
      commit(NOTIFICATIONALERT.SET_STARTTIME, startTime)
    },
    setFinishTime({commit}, finishTime){
      commit(NOTIFICATIONALERT.SET_FINISHTIME, finishTime)
    },
    clearRecipients({commit}){
      commit(NOTIFICATIONALERT.CLEAR_RECIPIENTS)
    },
    setId({commit}, id){
      commit(NOTIFICATIONALERT.SET_ID, id)
    },
  }
}
